import {
    useMemo
} from "react";
import {
    type TextStyle,
    StyleSheet
} from "react-native";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    text: {
        flexShrink: 1
    }
});

export const useStyles = ({
    duration,
    from,
    to
}: {
    duration: number;
    from: string;
    to: string;
}) => {
    const webShimmer = useMemo(() => StyleSheet.create({
        shimmer: webStyle({
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationKeyframes: {
                "0%, 100%": {
                    color: from
                },
                "50%": {
                    color: to
                }
            }
        })
    }).shimmer, [
        from,
        to
    ]);

    const styles = {
        webShimmer: [
            webShimmer,
            webStyle({
                animationDuration: `${duration}ms`
            })
        ] as Array<TextStyle>
    };

    return styles;
};
export default stylesheet;
